import type { ReactNode, FC, Ref } from "react";
import {
  Card,
  type ChildrenProp,
  type ClassNameProp,
  Flex,
  Grid,
  ScrollPane,
  Spacing,
  Text,
  Timeline,
  type TimelineRecord,
} from "@huub-web/ui";
import { mergeClasses } from "@huub-web/utils";

import {
  gridStyle,
  scrollPaneStyle,
  timelineStyle,
} from "./HouseValueTrend.css";
import { Tip } from "../Tip/Tip";

export type HouseValueTrendContentProps = ClassNameProp &
  ChildrenProp & {
    description?: string;
    woz?: {
      description?: ReactNode;
      records: TimelineRecord[];
      children?: ReactNode;
    };
    price?: {
      description?: ReactNode;
      records: TimelineRecord[];
      children?: ReactNode;
    };
    tips?: {
      description?: string;
    }[];
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * @deprecated
 */
export const HouseValueTrendContent: FC<HouseValueTrendContentProps> = ({
  description,
  woz,
  price,
  tips,
  children,
  ref,
}) => (
  <Flex ref={ref} direction="column" gap="s">
    {description && (
      <Text color="currentColor50" markdown>
        {description}
      </Text>
    )}
    <Spacing />
    <Grid variant="twoColumnMarketing" className={mergeClasses(gridStyle)}>
      {woz && (
        <Card border="default">
          <Text variant="bodyL" bold>
            WOZ-waarde verloop
          </Text>

          <Text variant="bodyS" color="currentColor50">
            {woz.description}
          </Text>

          <Spacing />

          <ScrollPane className={scrollPaneStyle}>
            <Timeline records={woz.records} className={timelineStyle} />
          </ScrollPane>

          {woz.children && (
            <>
              <Spacing />
              {woz.children}
            </>
          )}
        </Card>
      )}
      {price && (
        <Card border="default">
          <Text variant="bodyL" bold>
            Prijsverloop
          </Text>

          {price.description && (
            <Text variant="bodyS" color="currentColor50">
              {price.description}
            </Text>
          )}

          {price.description && <Spacing />}

          {price.records && price.records.length > 0 && (
            <ScrollPane className={scrollPaneStyle}>
              <Timeline records={price.records} className={timelineStyle} />
            </ScrollPane>
          )}

          {price.records && price.records.length > 0 && <Spacing />}

          {price.children && (
            <>
              <Spacing />
              {price.children}
            </>
          )}
        </Card>
      )}
    </Grid>

    {tips && (
      <>
        <Spacing />
        <Flex direction="column" gap="xs">
          {tips.map((tip, index) => (
            <Tip key={index}>{tip.description}</Tip>
          ))}
        </Flex>
      </>
    )}

    {children && (
      <>
        <Spacing />
        {children}
      </>
    )}
  </Flex>
);
